import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { ProductCalloutBlock } from "../components/ProductCalloutBlock";

type IProps = Immutable<templates.ProductCalloutBlockTemplate>;

export const Template = (props: IProps): React.JSX.Element => {
    return <ProductCalloutBlock value={props.value} />;
};
